import { Routes } from '@angular/router';
import { AuthGuard } from '@app/auth.guard';

export const APP_LAYOUT_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard], // Ensure the route is protected by AuthGuard
        loadChildren: () => import('../views/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'Adduser',
        loadChildren: () => import('../views/add-user/add-user.module').then(m => m.AddUserModule),
      },
      {
        path: 'printTicket',
        loadChildren: () => import('../views/print-ticket/print-ticket.module').then(m => m.PrintTicketModule),
      },
    
     
      {
        path: 'materialMix',
        loadChildren: () => import('../views/matrial-mix/matrial-mix.module').then(m => m.MatrialMixModule),
      },
      {
        path: 'materialMix/:id',
        loadChildren: () => import('../views/matrial-mix/matrial-mix.module').then(m => m.MatrialMixModule),
      },
     
      {
        path: 'UnsavedOrder',
        loadChildren: () => import('../views/unsaved-order/unsaved-order.module').then(m => m.UnsavedOrderModule),
      },
      {
        path: 'UnsavedOrder/:id',
        loadChildren: () => import('../views/unsaved-order/unsaved-order.module').then(m => m.UnsavedOrderModule),
      },
      {
        path: 'orderList',
        loadChildren: () => import('../views/order-list/order-list.module').then(m => m.OrderListModule),
      },
      {
        path: 'orderManager',
        loadChildren: () => import('../views/order-manager/order-manager.module').then(m => m.OrderManagerModule),
      },
      {
        path: 'place-order',
        loadChildren: () => import('../views/place-order/place-order.module').then(m => m.PlaceOrderModule)
      },
      // {
      //   path: 'edit/:id',
      //   loadChildren: () => import('../views/place-order/place-order.module').then(m => m.PlaceOrderModule)
      // },

      {
        path: 'confrmList',
        loadChildren: () => import('../views/confrm-list/confrm-list.module').then(m => m.ConfrmListModule)
      },
    
      {
        path: 'editorderList/:id',
        loadChildren: () => import('../views/order-list/order-list.module').then(m => m.OrderListModule),
      },
      {
        path: 'stock-bin-details',
        loadChildren: () => import('../views/stock-bin-details/stock-bin-details.module').then(m => m.StockBinDetailsModule)
      },

     
      {
        path: 'supply-materials',
        loadChildren: () => import('../views/supply-materials/supply-materials.module').then(m => m.SupplyMaterialsModule)
      },
      {
        path: 'supplyForm',
        loadChildren: () => import('../views/supplyform/supplyform.module').then(m => m.SupplyformModule)
      },
      {
        path: 'editMaterialList/:id',
        loadChildren: () => import('../views/supply-materials/supply-materials.module').then(m => m.SupplyMaterialsModule)
      },
      {
        path: 'factory-issue',
        loadChildren: () => import('../views/factory-issue/factory-issue.module').then(m => m.FactoryIssueModule)
      },
      {
        path: 'UserProfile',
        loadChildren: () => import('../views/user-profile/user-profile.module').then(m => m.UserProfileModule),
      },
      {

        path: 'addclient',
        loadChildren: () => import('../views/add-client/add-client.module').then(m => m.AddClientModule),
      },
      {

        path: 'clientList',
        loadChildren: () => import('../views/user-list/user-list.module').then(m => m.UserListModule),
      }, {

        path: 'edituserList/:id',
        loadChildren: () => import('../views/add-client/add-client.module').then(m => m.AddClientModule),
      },

      {
        path: 'repeatedorderlist',
        loadChildren: () => import('../views/repeated-order-list/repeated-order-list.module').then(m => m.RepeatedOrderListModule),
      },


      {

        path: 'CustomerList',
        loadChildren: () => import('../views/customer-list/customer-list.module').then(m => m.CustomerListModule),
      },
      {
        path: 'Reports',
        // loadChildren: () => import('../views/reports/reports.module').then(m => m.ReportsModule),
         loadChildren: () => import('../views/parents-order/parents-order.module').then(m => m.ParentsOrderModule),

      },
      {

        path: 'jsslist',
        loadChildren: () => import('../views/jss-list/jss-list.module').then(m => m.JssListModule),
      },

      {
        path: 'editjsslist/:id',
        loadChildren: () => import('../views/jss-list/jss-list.module').then(m => m.JssListModule),
      },
      {

        path: 'jssCreation',
        loadChildren: () => import('../views/jss-creation/jss-creation.module').then(m => m.JssCreationModule),
      },
      {
        path: 'jssCreation/:id',
        loadChildren: () => import('../views/jss-creation/jss-creation.module').then(m => m.JssCreationModule),
      },
      {
        path: 'productionForm',
        loadChildren: () => import('../views/production-form/production-form.module').then(m => m.ProductionFormModule),
      },
      {
        path: 'addMaterial',
        loadChildren: () => import('../views/add-material/add-material.module').then(m => m.AddMaterialModule),
      },
      {
        path: 'inventory',
        loadChildren: () => import('../views/inventory-list/inventory-list-routing.module').then(m => m.InventoryListRoutingModule),
      },
      {
        path: 'inventoryii',
        loadChildren: () => import('../views/inventory-listii/inventory-listii-routing.module').then(m => m.InventoryListiiRoutingModule),
      },
      {
        path: 'inventoryiii',
        loadChildren: () => import('../views/inventory-listiii/inventory-listiii-routing.module').then(m => m.InventoryListiiiRoutingModule),
      },
      {
        path: 'addProd',
        loadChildren: () => import('../views/add-prod/add-prod.module').then(m => m.AddProdModule),
      },
      {
        path: 'addInk',
        loadChildren: () => import('../views/add-ink/add-ink.module').then(m => m.AddInkModule)
      },
      {
        path: 'process',
        loadChildren: () => import('../views/process/process.module').then(m => m.ProcessModule)
      },
      {
        path: 'MaterialList',
        loadChildren: () => import('../views/material-list/material-list.module').then(m => m.MaterialListModule)
      },
      {
        path: 'Inventory Master',
        loadChildren: () => import('../views/popup-in/popup-in.module').then(m => m.PopupInModule)
      },
      {
        path: 'DispatchForm/:id',
        loadChildren: () => import('../views/dispatch/dispatch-from/dispatch-from.module').then(m => m.DispatchFromModule)
      },
      {
        path: 'DispatchTable',
        loadChildren: () => import('../views/dispatch/dispatch-table/dispatch-table.module').then(m => m.DispatchTableModule)
      },
      {
        path: 'DispatchRemainTable',
        loadChildren: () => import('../views/dispatch/remain-dispatch-table/remain-dispatch-table.module').then(m => m.RemainDispatchTableModule)
      },
      {
        path:'DispatchGroupTable',
        loadChildren: () => import('../views/dispatch/group-way-bill/group-way-bill.module').then(m => m.GroupWayBillModule)
      },
      {
        path: 'MATERILAIS',
        loadChildren: () => import('../views/material-list/material-list.module').then(m => m.MaterialListModule)
      },

      {
        path: 'productionTable',
        loadChildren: () => import('../views/prod-table/prod-table.module').then(m => m.ProdTableModule)
      },
      {
        path: 'productionForm/:id',
        loadChildren: () => import('../views/production-form/production-form.module').then(m => m.ProductionFormModule),
      },

      //reference
      {
        path: 'prodForm',
        loadChildren: () => import('../views/prod-form/prod-form.module').then(m => m.ProdFormModule),
      },
      {
        path: 'prodForm/:id',
        loadChildren: () => import('../views/prod-form/prod-form.module').then(m => m.ProdFormModule),
      },

      {
        path: 'prodRecord',
        loadChildren: () => import('../views/prod-rec/prod-rec.module').then(m => m.ProdRecModule),
      },

      {
        path: 'editproductionorderList/:id',
        loadChildren: () => import('../views/prod-form/prod-form.module').then(m => m.ProdFormModule),
      },


      //ref
      {
        path: 'prodInfo',
        loadChildren: () => import('../views/production/production-info/production-info.module').then(m => m.ProductionInfoModule)
      },
      {
        path: 'LabelPrint',
        loadChildren: () => import('../views/product/label-print/label-print.module').then(m => m.LabelPrintModule)
      },
      {
        path: 'LabelPrintList',
        loadChildren: () => import('../views/product/label-print-list/label-print-list.module').then(m => m.LabelPrintListModule)
      },

      {
        path: 'printingProduction',
        loadChildren: () => import('../views/printing-production/printing-production.module').then(m => m.PrintingProductionModule),
      },
      {
        path: 'editprintingProduction/:id',
        loadChildren: () => import('../views/printing-production/printing-production.module').then(m => m.PrintingProductionModule),
      },

      // {
      //   path: 'laminationProduction',
      //   loadChildren: () => import('../views/lamination-production/lamination-production.module').then(m => m.LaminationProductionModule),
      // },
      {
        path: 'laminationProd',
        loadChildren: () => import('../views/lam-prod/lam-prod.module').then(m => m.LamProdModule),
      },
      {
        path: 'laminationTable',
        loadChildren: () => import('../views/lamprod-table/lamprod-table.module').then(m => m.LamprodTableModule),
      },

      {
        path: 'printingProd',
        loadChildren: () => import('../views/print-prod/print-prod.module').then(m => m.PrintProdModule),
      },

      {
        path: 'editprintingProd/:id',
        loadChildren: () => import('../views/print-prod/print-prod.module').then(m => m.PrintProdModule),
      },






      {
        path: 'printingProdForm',
        loadChildren: () => import('../views/productionForms/printing-test/printing-test.module').then(m => m.PrintingTestModule),
      },

      {
        path: 'laminationProdForm',
        loadChildren: () => import('../views/productionForms/lamination-test/lamination-test.module').then(m => m.LaminationTestModule),
      },

      {
        path: 'slittingProdForm',
        loadChildren: () => import('../views/productionForms/slitting-test/slitting-test.module').then(m => m.SlittingTestModule),
      },

      {
        path: 'printingProdTable',
        loadChildren: () => import('../views/productionForms/printing-test-table/printing-test-table.module').then(m => m.PrintingTestTableModule),
      },

      {
        path: 'slittingProdTable',
        loadChildren: () => import('../views/productionForms/slitting-test-table/slitting-test-table.module').then(m => m.SlittingTestTableModule),
      },

      {
        path: 'laminationProdTable',
        loadChildren: () => import('../views/productionForms/lamination-test-table/lamination-test-table.module').then(m => m.LaminationTestTableModule),
      },



      //
       {
        path: 'glueingProdForm',
        loadChildren: () => import('../views/productionForms/glueing-test/glueing-test.module').then(m => m.GlueingTestModule),
      },
      {
        path: 'glueingProdTable',
        loadChildren: () => import('../views/productionForms/glueing-test-table/glueing-test-table.module').then(m => m.GlueingTestTableModule),
      },

      {
        path: 'extrusionProdForm',
        loadChildren: () => import('../views/productionForms/extrusion-test/extrusion-test.module').then(m => m.ExtrusionTestModule),
      },

      {
        path: 'extrusionProdTable',
        loadChildren: () => import('../views/productionForms/extrusion-test-table/extrusion-test-table.module').then(m => m.ExtrusionTestTableModule),
      },

       {
        path: 'remaProdForm',
        loadChildren: () => import('../views/productionForms/rema-test/rema-test.module').then(m => m.RemaTestModule),
      },
      {
        path: 'printingResult',
        loadChildren: () => import('../views/dprReports/printing-week-res/printing-week-res.module').then(m => m.PrintingWeekResModule),
      },

      {
        path: 'remaProdTable',
        loadChildren: () => import('../views/productionForms/rema-test-table/rema-test-table.module').then(m => m.RemaTestTableModule),
      },


      // dpr reports
       {
        path: 'printingWeekData',
        loadChildren: () => import('../views/productionForms/rema-test-table/rema-test-table.module').then(m => m.RemaTestTableModule),
      },




      {
        path: 'editDispatchTable/:ticketno',
        loadChildren: () => import('../views/dispatch/dispatch-table/dispatch-table.module').then(m => m.DispatchTableModule)
      },

    ]
  }
]

